import { UIIcon } from '@dropbox/dig-icons';
import { ChevronLeftLine } from '@dropbox/dig-icons/assets';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  useSignatureRequestContext,
  useFieldsContext,
} from 'signer-app/signature-request/context';
import { useSignerAppParams, useSignerContext } from '../signer-experience';
import messages from 'signer-app/signer-experience/signer-toolbar/messages';
import {
  IconButton,
  IconButtonProps,
  IconButtonVariant,
} from '@dropbox/dig-components/buttons';

export function PreviousButton({
  variant = 'outline',
  size,
}: {
  variant?: IconButtonVariant;
  size?: IconButtonProps['size'];
}) {
  const intl = useIntl();
  const { selectedFieldIds } = useSignatureRequestContext();
  const { selectField } = useSignerContext();
  const fields = useFieldsContext();
  const [activeField] = selectedFieldIds;
  const currentFieldIndex = fields.findIndex((f) => f.id === activeField);
  const { step } = useSignerAppParams();

  function handlePrevious() {
    if (step === 'attachments') {
      selectField(fields[fields.length - 1].id);
      return;
    }

    if (!activeField) {
      const field = fields[0];
      selectField(field.id);
      return;
    }

    const prevIndex = currentFieldIndex - 1;
    const field = fields[prevIndex];
    selectField(field.id);
  }

  // Only show this button if there is a previous field to navigate to
  if (currentFieldIndex === 0) {
    return null;
  }

  return (
    <IconButton
      size={size}
      variant={variant}
      onClick={handlePrevious}
      aria-label={intl.formatMessage(messages.prevButton)}
    >
      <UIIcon src={ChevronLeftLine} />
    </IconButton>
  );
}
